import { render, staticRenderFns } from "./MatchDetail.vue?vue&type=template&id=03bd9053&scoped=true"
import script from "./MatchDetail.vue?vue&type=script&lang=js"
export * from "./MatchDetail.vue?vue&type=script&lang=js"
import style0 from "./MatchDetail.vue?vue&type=style&index=0&id=03bd9053&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bd9053",
  null
  
)

export default component.exports